import { render, staticRenderFns } from "./recitersView.vue?vue&type=template&id=8785050c&scoped=true&"
import script from "./recitersView.vue?vue&type=script&lang=js&"
export * from "./recitersView.vue?vue&type=script&lang=js&"
import style0 from "./recitersView.vue?vue&type=style&index=0&id=8785050c&prod&lang=scss&scoped=true&"
import style1 from "./recitersView.vue?vue&type=style&index=1&id=8785050c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8785050c",
  null
  
)

export default component.exports